import PropTypes from "prop-types";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

/**
 * "All branches" + per-branch filter dropdown for a main-church admin
 * browsing a now branch-scoped list page. Pass `value=""` for "all branches".
 * Renders nothing for branch_admin users or single-site churches — gate
 * with `useBranches().canFilterByBranch` before rendering this.
 */
function BranchFilterSelect({ branches, value, onChange, size, sx }) {
  return (
    <FormControl size={size} sx={{ minWidth: 180, ...sx }}>
      <InputLabel id="branch-filter-label">Branch</InputLabel>
      <Select
        labelId="branch-filter-label"
        label="Branch"
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <MenuItem value="">All Branches</MenuItem>
        {branches.map((b) => (
          <MenuItem key={b.id} value={b.id}>
            {b.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

BranchFilterSelect.propTypes = {
  branches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  size: PropTypes.string,
  sx: PropTypes.object,
};

BranchFilterSelect.defaultProps = {
  value: "",
  size: "small",
  sx: {},
};

export default BranchFilterSelect;
